import { createPortal } from "react-dom";
import { X } from "lucide-react";
import giftImg from "@/assets/images/gift.png";

/**
 * One-time "Account created" welcome shown right after registration, prompting
 * the user to activate their card and claim the $5 reward. Rendered as a bottom
 * sheet on mobile (centered dialog on desktop). "Apply now" goes to the Card
 * screen. Visibility / once-only logic lives in the parent.
 */
const WelcomeRewardModal = ({ open, onClose, onApply }) => {
  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[80] flex items-end justify-center bg-black/40 sm:items-center sm:px-5"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="w-full rounded-t-[28px] bg-white px-6 pb-[max(24px,env(safe-area-inset-bottom,0px))] pt-3 shadow-2xl sm:max-w-[420px] sm:rounded-[28px] sm:pb-6"
        role="dialog"
        aria-modal="true"
        aria-label="Account created"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Drag handle */}
        <div
          className="mx-auto mb-4 h-1.5 w-10 rounded-full bg-[#E5E7EB]"
          aria-hidden
        />

        {/* Header */}
        <div className="relative flex items-center justify-center">
          <h2 className="text-[17px] font-semibold text-gray-900">
            Account created
          </h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="absolute right-0 rounded-lg p-1 text-[#98A2B3] transition-colors hover:bg-[#F2F2F7]"
          >
            <X className="size-5" strokeWidth={1.75} />
          </button>
        </div>

        {/* Gift illustration */}
        <div className="mt-[10px] flex justify-center">
          <img
            src={giftImg}
            alt=""
            className="h-[150px] w-auto object-contain"
            aria-hidden
          />
        </div>

        {/* Message */}
        <p className="mt-[10px] text-[20px] font-bold leading-[1.45] text-gray-900">
          Activate your card to use your 5 USD reward before it expires in 30
          days
        </p>

        {/* CTA */}
        <button
          type="button"
          onClick={onApply}
          className="mt-6 w-full rounded-2xl bg-[#497AFF] py-4 text-[15px] font-semibold text-white transition-opacity hover:opacity-90"
        >
          Apply now
        </button>
      </div>
    </div>,
    document.body,
  );
};

export default WelcomeRewardModal;
